import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './App.scss';
import HeaderContainer from '../header/Header';
import FooterContainer from '../footer/Footer';
import AnnotationsSidebar from '../annotationsSidebar/AnnotationsSidebar';
import AdditionalResourcesBar from '../additionalResourcesBar/AdditionalResourcesBar';
import studentHighlightsActions from '../../actions/StudentHighlightsActions';
import annotationService from '../../services/AnnotationService';
import storeManager from '../../store/StoreManager';
import questionSelectionService from '../../services/QuestionSelectionService';

import annotationItemStyles from '../annotationsSidebar/annotationItem/annotationItem.scss';
import ChatSidebar from '../chatSidebar/ChatSidebar';
import appMainScreenSelector from '../../selectors/app/AppMainScreenSelector';
import ZoomWrapper from '../remoteOralExam/zoomIntegration/ZoomWrapper';

const AppMainScreen = (props) => {
    const {
        children,
        addAppWrapper,
        showFooter,
        showChatSidebar,
        showHeader,
        isNoteTakingAndHighlightingEnabled,
        isCurrentWordFormationQuestion,
        showAdditionalResourcesBar,
        showAnnotationsSidebar,
        showZoomCall,
        isAreaHidden,
        isMarksOnlyAccess,
        isNotesPanelFixedWidthEnabled,
        annotationSidebarInlineStyles,
    } = props;

    const contentContainerStyles = [styles.contentContainer];
    const isCSCB = questionSelectionService.isCandidateSelectedContentBlockEnabled();

    if (!showHeader) {
        contentContainerStyles.push('header-disabled');
    }

    if (isCurrentWordFormationQuestion) {
        contentContainerStyles.push(styles.wordFormationQuestionContainer);
    }

    if (isCSCB) {
        contentContainerStyles.push(styles.cscbApp);
    }

    const AppContainerComponent = addAppWrapper
        ? children
        : (<div id="appContentContainer" className={contentContainerStyles.join(' ')}>
            {children}
        </div>);

    const HeaderComponent = showHeader ? <HeaderContainer showFooter={showFooter} /> : null;
    const FooterComponent = showFooter ? <FooterContainer /> : null;
    const AdditionalResourcesBarComponent = showAdditionalResourcesBar ? <AdditionalResourcesBar /> : null;
    const ChatSidebarComponent = showChatSidebar ? <ChatSidebar /> : null;
    const ZoomIntegrationComponent = showZoomCall ? <ZoomWrapper /> : null;

    const onAppMainScreenClick = (e) => {
        const store = storeManager.getStore();

        const isAnnotationRelatedNode = e.target.closest(`.${annotationItemStyles.annotationItem}`) || e.target.closest('.hypothesis-highlight');

        if (!isAnnotationRelatedNode) {
            store.dispatch(studentHighlightsActions.setFocusedAnnotation(null));
            annotationService.dispatchFocusAnnotationEvent(null);
        }
    };

    const mainScreenContainerClassNamesList = [styles.appMainScreen];
    if (showAnnotationsSidebar && isNotesPanelFixedWidthEnabled) {
        mainScreenContainerClassNamesList.push(styles.useNotesPanelWithFixedWidth);
    }
    const mainScreenContainerClassNames = mainScreenContainerClassNamesList.join(' ');


    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            aria-hidden={isAreaHidden}
            className={mainScreenContainerClassNames}
            onClick={isNoteTakingAndHighlightingEnabled ? onAppMainScreenClick : undefined}
        >
            <div className={styles.mainScreenContent} id="main-screen-content">
                {HeaderComponent}
                {AppContainerComponent}
                {ZoomIntegrationComponent}
                {!isMarksOnlyAccess && (<div className={styles.footerWrapper} id="footer-wrapper">
                    {FooterComponent}
                    {AdditionalResourcesBarComponent}
                </div>)}
            </div>
            {/* AnnotationsSidebar is kept always mounted and only hidden via display:none
                to avoid lag when opening the sidebar, as its initial mount is relatively expensive. */}
            <div
                style={annotationSidebarInlineStyles}
                aria-hidden={!showAnnotationsSidebar}
            >
                <AnnotationsSidebar />
            </div>
            {ChatSidebarComponent}
        </div>
    );
};

AppMainScreen.propTypes = {
    addAppWrapper: PropTypes.bool.isRequired,
    children: PropTypes.object,
    isNoteTakingAndHighlightingEnabled: PropTypes.bool.isRequired,
    isCurrentWordFormationQuestion: PropTypes.bool.isRequired,
    showAdditionalResourcesBar: PropTypes.bool.isRequired,
    showAnnotationsSidebar: PropTypes.bool.isRequired,
    showChatSidebar: PropTypes.bool.isRequired,
    showFooter: PropTypes.bool.isRequired,
    showHeader: PropTypes.bool.isRequired,
    showZoomCall: PropTypes.bool.isRequired,
    isAreaHidden: PropTypes.bool.isRequired,
    isMarksOnlyAccess: PropTypes.bool.isRequired,
    isNotesPanelFixedWidthEnabled: PropTypes.bool.isRequired,
    annotationSidebarInlineStyles: PropTypes.object.isRequired,
};

const mapStateToProps = state => appMainScreenSelector.selectProps(state);
export default connect(mapStateToProps)(AppMainScreen);
